export default __webpack_public_path__ + "static/media/img4.8fab6974.png";